/* I&C redesign · motion module "letters": gold-dust canvas that parts around the cursor, drawn top rule, staged entrance,
   focus ripple on the email line, Subscribe press. Vanilla, scoped to .rd .letters; no-op under reduced motion. */
(function () {
  'use strict';
  function init() {
    var sec = document.querySelector('.rd .letters');
    if (!sec || sec.hasAttribute('data-rd-m-letters')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    sec.setAttribute('data-rd-m-letters', '');
    sec.classList.add('rd-m-letters');

    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var phone = window.matchMedia('(max-width: 767px)').matches;
    var mk = function (tag, cls, parent, first) {
      var el = document.createElement(tag); el.className = cls; el.setAttribute('aria-hidden', 'true');
      if (first && parent.firstChild) parent.insertBefore(el, parent.firstChild); else parent.appendChild(el);
      return el;
    };

    /* ---- decorative layers ---- */
    var canvas = mk('canvas', 'rd-m-letters__dust', sec, true);
    mk('span', 'rd-m-letters__pool', sec, true);
    mk('span', 'rd-m-letters__rule', sec);

    var em = sec.querySelector('h2 em');                               // sheen copy of the italic word (plain, short text only)
    if (em && !em.children.length && em.textContent.trim().length && em.textContent.length <= 24) em.setAttribute('data-rd-m-text', em.textContent);

    /* ---- form: glow line, ripple, halo, button press, ready state ---- */
    var form = sec.querySelector('form'), input = form && form.querySelector('input[type="email"]'), btn = form && form.querySelector('button[type="submit"]');
    if (form) {
      var glow = mk('span', 'rd-m-letters__glow', form), ripple = mk('span', 'rd-m-letters__ripple', glow);
      mk('span', 'rd-m-letters__line', glow); mk('span', 'rd-m-letters__halo', form);
      ripple.addEventListener('animationend', function () { form.classList.remove('rd-m-ripple'); });
      if (input) {
        input.addEventListener('focus', function () { form.classList.remove('rd-m-ripple'); void ripple.offsetWidth; form.classList.add('rd-m-ripple'); });
        var ready = function () { form.classList.toggle('rd-m-ready', !!input.value && input.validity.valid); };
        input.addEventListener('input', ready); ready();
      }
      if (btn) {
        btn.addEventListener('animationend', function () { btn.classList.remove('rd-m-pressed'); });
        var press = function () { btn.classList.remove('rd-m-pressed'); void btn.offsetWidth; btn.classList.add('rd-m-pressed'); };
        btn.addEventListener('pointerdown', press, { passive: true });
        btn.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') press(); });
      }
    }

    /* ---- gold dust ---- */
    var ctx = canvas.getContext('2d'), W = 0, H = 0, dpr = 1, motes = [], sprite = null, SR = 16;
    var px = -1e4, py = -1e4, rect = null, needRect = false, R = 170, R2 = R * R;
    var COUNT = phone ? 25 : 60, visible = false, running = false, inView = false, last = 0, t = 0, raf = 0;
    var rand = function (a, b) { return a + Math.random() * (b - a); };
    var makeSprite = function () {                                 // same look as the hero's dust: warm core, soft gold bloom
      var c = document.createElement('canvas'), s = SR * dpr; c.width = c.height = s * 2;
      var g = c.getContext('2d'), r = g.createRadialGradient(s, s, 0, s, s, s);
      r.addColorStop(0, 'rgba(255,230,180,1)'); r.addColorStop(0.35, 'rgba(240,200,130,0.7)'); r.addColorStop(1, 'rgba(240,200,130,0)');
      g.fillStyle = r; g.beginPath(); g.arc(s, s, s, 0, Math.PI * 2); g.fill(); sprite = c;
    };
    var spawn = function (anywhere) {
      var front = Math.random() < 0.14, z = front ? rand(1.4, 2) : rand(0.4, 1);
      return { x: rand(0, W), y: anywhere ? rand(0, H) : H + rand(6, 40), z: z, front: front,
        s: rand(0.55, 0.95) * z,                                   // bloom radius = s * 2.4  ->  1–2 px visible core
        vx: rand(-0.06, 0.06), vy: -rand(0.035, 0.12) * z, tw: rand(0.6, 1.6), ph: rand(0, 6.3), ox: 0, oy: 0 };
    };
    var measure = function () {
      var w = sec.clientWidth, h = sec.clientHeight; if (!w || !h) return;
      dpr = Math.min(window.devicePixelRatio || 1, phone ? 1.5 : 2);
      var sx = W ? w / W : 1, sy = H ? h / H : 1; W = w; H = h;
      canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0); makeSprite();
      if (!motes.length) { for (var i = 0; i < COUNT; i++) motes.push(spawn(true)); }
      else motes.forEach(function (p) { p.x *= sx; p.y *= sy; });
      needRect = true;
    };
    var draw = function (now) {
      if (!running) return;
      var dt = last ? Math.min((now - last) / 16.667, 3) : 1; last = now; t += dt / 60;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < motes.length; i++) {
        var p = motes[i];
        p.x += (p.vx + Math.sin(t * 0.7 + p.ph) * 0.1) * dt; p.y += p.vy * dt;
        if (p.y < -30 || p.x < -30 || p.x > W + 30) { motes[i] = p = spawn(false); }
        if (fine) {                                              // part gently away from the cursor, then ease back
          var dx = p.x + p.ox - px, dy = p.y + p.oy - py, d2 = dx * dx + dy * dy;
          if (d2 < R2 && d2 > 0.01) { var d = Math.sqrt(d2), f = (1 - d / R) * (1 - d / R) * 3.2 * dt; p.ox += dx / d * f; p.oy += dy / d * f; }
          var k = Math.pow(0.975, dt); p.ox *= k; p.oy *= k;
        }
        var a = 0.35 + 0.45 * Math.abs(Math.sin(t * p.tw + p.ph)), r = p.s * 2.4;
        ctx.globalAlpha = (p.front ? 0.3 : 0.4 + 0.35 * p.z) * a;
        ctx.drawImage(sprite, p.x + p.ox - r, p.y + p.oy - r, r * 2, r * 2);
      }
      raf = window.requestAnimationFrame(draw);
    };
    var update = function () {
      var want = visible && !document.hidden;
      if (want === running) return;
      running = want; last = 0; canvas.setAttribute('data-rd-m-run', want ? '1' : '0');
      sec.classList.toggle('rd-m-on', want);
      if (want) raf = window.requestAnimationFrame(draw); else window.cancelAnimationFrame(raf);
    };
    measure();
    if ('ResizeObserver' in window) new ResizeObserver(function () { measure(); }).observe(sec);
    else window.addEventListener('resize', measure, { passive: true });
    document.addEventListener('visibilitychange', update);
    if (fine) {
      sec.addEventListener('pointerenter', function () { needRect = true; }, { passive: true });
      sec.addEventListener('pointermove', function (e) {               // rect is re-read only after scroll / resize / enter, never in draw()
        if (needRect || !rect) { rect = sec.getBoundingClientRect(); needRect = false; }
        px = e.clientX - rect.left; py = e.clientY - rect.top;
      }, { passive: true });
      sec.addEventListener('pointerleave', function () { px = py = -1e4; }, { passive: true });
      window.addEventListener('scroll', function () { needRect = true; }, { passive: true });
    }

    /* ---- entrance + run state ---- */
    var enter = function () {
      if (inView) return; inView = true;
      sec.classList.add('rd-m-in');
      window.setTimeout(function () { sec.classList.add('rd-m-drawn'); }, 2700);
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          visible = en.isIntersecting;
          if (en.isIntersecting && (en.intersectionRatio >= 0.22 || en.intersectionRect.height >= window.innerHeight * 0.6)) enter();
        });
        update();
      }, { threshold: [0, 0.22, 0.5] }).observe(sec);
    } else { visible = true; enter(); update(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
